import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import { format, subDays } from "date-fns";
import { JSConn } from "@/utilities/js-conn";

require("vue-simple-calendar/static/css/default.css");

export default {
  name: "calendar",
  components: {
    LoadingAnimation,
    CalendarView,
    CalendarViewHeader,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading schedule...",
      showDate: new Date(),
      calendarEvents: [],
      idsIndex: {},
      calendarOptions: {
        from_date: "",
      },
    };
  },
  created() {
    const fromDate = subDays(new Date(), 7);
    this.calendarOptions.from_date = format(fromDate, "yyyy-MM-dd");

    this.loadScheduledWorkOrders();

    this.dataLoaded = true;
  },
  computed: {
    workOrdersAsEvents: function() {
      return this.$store.getters.workOrdersAsEvents;
    },
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    loadScheduledWorkOrders() {
      const jsConnScheduledWorkOrders = new JSConn();

      jsConnScheduledWorkOrders.formParams = {
        scheduled_after_date: this.calendarOptions.from_date,
      };

      const dataPromises = [
        this.$store.dispatch("needWorkOrders", jsConnScheduledWorkOrders),
      ];

      Promise.all(dataPromises).then(() => {
        this.calendarEvents = this.workOrdersAsEvents;
        this.dataLoaded = true;
      });
    },
    clickedEvent(event) {
      this.$router.push({
        name: "workOrderTasks",
        params: {
          workOrderId: event.id,
        },
      });
    },
    droppedOnDate(event, date) {
      // update and get the data again
      const jsConn = new JSConn();
      jsConn.formParams = {
        id: event.id,
        scheduled_date: format(date, "yyyy-MM-dd"),
      };

      this.$store.dispatch("updateWorkOrder", jsConn).then(() => {
        this.loadScheduledWorkOrders();
      });
    },
  },
};
